<template>

    <div class="col">
      <div class="content-i">
        <div class="content-box pt-0">
          <h5 class="form-header">
            Meus Dados
          </h5>
          <div class="element-box">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="row">
                      <div class="col">
                        <div class="label">
                          Nome Completo
                        </div>
                        <div class="value">
                          <h5>{{client.name}}</h5>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div class="label">
                          Email
                        </div>
                        <div class="value">
                          <h5>{{client.email}}</h5>
                        </div>
                      </div>
                    </div>
                    <div class="row" v-if="cartao">
                      <div class="col">
                        <div class="label">
                          Dr.Achei Card
                        </div>
                        <div class="value">
                          <h5>{{cartao.numeroCartao.replace(/(\d\d\d\d)(\d\d\d\d)(\d\d\d\d)(\d\d\d\d)/g, '$1 $2 $3 $4')}}</h5>
                        </div>
                      </div>
                      <div class="col">
                        <div class="label">
                          Plano
                        </div>
                        <div class="value">
                          <h5>{{pedido.plano.name}}
                            <small>({{pedido.plano.price | money}}/mês)</small>
                          </h5>
                        </div>
                      </div>
                      <div class="col">
                        <div class="label">
                          Status
                        </div>
                        <div class="value">

                          <h5><span class="status-pill smaller"
                              :class="{'green': cartao.status === 'HABILITADO'}"></span> {{cartao.status}}</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-sm-12" v-if="cartao && dependentes.length > 0">
                    <div class="label">
                      Dependentes
                    </div>
                    <div class="users-list-w dependentes-list">
                      <div class="user-w"
                        v-for="dependente in dependentes"
                        :key="dependente.cpf">
                        <div class="user-avatar-w">
                          <div class="user-avatar">
                            <i class="os-icon os-icon-user-male-circle2"></i>
                          </div>
                        </div>
                        <div class="user-name">
                          <h6 class="user-title">
                            {{dependente.name}}
                          </h6>
                          <div class="user-role">
                            CPF: {{dependente.cpf}}
                          </div>
                        </div>
                        <a class="user-action">
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <hr>
                <div class="row">
                  <div class="col">
                    <small>Em caso de cancelamento de algum pedido ou
plano entrar em contato com A CENTRAL DE ATENDIMENTO número (21) 2263-9325 ou
enviar email para <a href="mailto:contato@gruposin.com.br">contato@gruposin.com.br</a></small>
                  </div>
                </div>
              </div>
        </div>
      </div>
    </div>

</template>
<script>
import * as http from 'axios'
export default {
  computed: {
    user () {
      return this.$store.getters.user
    },
    pedido () {
      if (this.cartao) {
        return this.cartao.pedido
      } else {
        return {}
      }
    },
    dependentes () {
      if (this.pedido && this.pedido.client) {
        return this.pedido.client.dependentes
      } else {
        return []
      }
    },
    client () {
      return this.pedido.client
    }
  },
  data () {
    return {
      cartao: null
    }
  },
  mounted () {
    if (this.user && this.user.cartao) {
      http.get(`/cartao/id/${this.user.cartao._id}`)
        .then(response => {
          this.cartao = response.data
        })
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/pages/dashboard-cliente/MeusDadosCliente.vue